export const SEARCH_REQUEST = "SEARCH_REQUEST";
export const SEARCH_SUCCESS = "SEARCH_SUCCESS";
export const SEARCH_FAILURE = "SEARCH_FAILURE";
export const SEARCH_APPEND = "SEARCH_APPEND";
export const SET_QUERY = "SET_QUERY";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
